<template>
<div class="content">
  <div class="container-fluid">

    <transition name="fade-in">
      <div v-if="try_out.showModal" class="assessment-modal-overlay">
        <div class="assessment-modal">
          <div class="title">
            <span class="fas fa-cog fa-3x fa-spin"></span>
            <span class="build_title">{{try_out.build_title}}</span>
          </div>
          <div class="description">Please, wait for this process to finish</div>
          <div v-if="try_out.build_status" class="build_status">Current State: {{try_out.build_status}}</div>
          <div class="buttons">
            <a v-if="try_out.build_url" class="btn btn-primary btn-fill btn-sm" :href="try_out.build_url" target="_blank">Check Logs</a>
            <button class="btn btn-sm btn-danger btn-fill" @click="cancelPipeline()">Cancel</button>
          </div>
        </div>
      </div>
    </transition>


    <div class="card">

      <div class="card-header">
        <router-link to="/pipeline-as-a-service" class="btn btn-default btn-simple">
          <i class="fa fa-arrow-left"></i> <span class="card-title">Back</span>
        </router-link>
      </div>

      <div class="card-body">


        <div class="pipeline-result" :class="[pipeline_status]" style="display: flex">

          <div v-if="pipeline_status === 'creating'">
            <div class="title">Your pipeline is being created</div>
            <div>Please, wait a few moments to finish...</div>
            <div class="progress">
              <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="'width: '+((pipeline_loading_counter/5)*100+10)+'%'">{{((pipeline_loading_counter/5)*100+10)}}%</div>
            </div>
          </div>

          <div v-else-if="pipeline_status === 'error'">
            <div class="title">Your pipeline has failed</div>
            <div class="description">{{pipeline_error_description}}</div>
            <router-link to="/pipeline-as-a-service">
              <button class="btn btn-primary btn-fill"><i class="fa fa-arrow-left "></i>Back</button>
            </router-link>
          </div>

          <div v-else-if="pipeline_status === 'created'">
            <div class="title">Your pipeline has been successfully created!</div>
            <div class="description">The CI/CD pipeline is now ready to use. The SQAaaS provides further support for executing and/or downloading. You could even push it directly to your own git repository.</div>
          </div>

          <div class="icon">
            <img src="../../static/pipeline.png" alt="Pipeline icon">
          </div>
        </div>


        <div v-if="pipeline_status === 'created'" >
          <div class="tabs">
            <div class="tab summary" @click="tab_selected='summary'" :class="{active: tab_selected === 'summary'}" style="display: flex">
              <img src="../../static/summary.png" alt="Config Summary">
              <div class="title">Config summary</div>
              <div class="description">Provides a table-like view with the selections made when the pipeline was composed</div>
            </div>
            <div class="tab jepl_files" @click="tab_selected='files'" :class="{active: tab_selected === 'files'}" style="display: flex">
              <img src="../../static/jepl_files.png" alt="JePL files">
              <div class="title">JePL files</div>
              <div class="description">Check out the files that drive the execution of the pipeline</div>
            </div>
            <div class="tab pull_request" @click="tab_selected='pull_request'" :class="{active: tab_selected === 'pull_request'}" style="display: flex">
              <img src="../../static/pull-request.png" alt="Pull request">
              <div class="title">Pull request</div>
              <div class="description">Create a pull request to add the pipeline to your preferred repository</div>
            </div>
            <div class="tab run_pipeline" @click="tab_selected='run_pipeline'" :class="{active: tab_selected === 'run_pipeline'}" style="display: flex">
              <img src="../../static/play.png" alt="Try out">
              <div class="title">Try out</div>
              <div class="description">Execute the composed pipeline and check the results</div>
            </div>
          </div>

          <transition name="fade" mode="out-in">
            <div class="card summary" v-if="tab_selected === 'summary'" key="summary">
              <div class="card-body">
                <div class="pipeline_name"><span class="title">Pipeline name:</span> {{criteria.pipeline_name}}</div>

                 <div v-for="criterion in criteria.criteria" :key="criterion.criterionID">
                  <div class="criteria_item" style="display: flex"><i class="fa fa-compass"></i> Criterion: {{criterion.criterionID}}</div>

                  <div v-for="tool in criterion.tools" :key="tool.tool.name" class="tool_item">
                    <div class="tool_title" style="display: flex"><span class="tool_name"><i class="fa fa-cogs"></i> <span class="tool_data_title">Tool:</span> {{tool.tool.name}}</span></div>
                    <div v-if="tool.external_repo.url" class="tool_data"> <span class="tool_data_title">External repo:</span> {{tool.external_repo.url}}/{{tool.external_repo.branch}}</div>
                    <div v-for="arg in tool.tool.args">
                      <div v-if="arg.selectable && arg.format === 'string' && arg.value" class="tool_data"> <span class="tool_data_title">{{arg.description}}:</span> {{arg.value}}</div>
                      <div v-else-if="arg.selectable && arg.format === 'array' && arg.value" class="tool_data"> <span class="tool_data_title">{{arg.description}}:</span> {{arg.inputValue}}</div>
                    </div>
                    <div v-if="tool.image" class="tool_data"> <span class="tool_data_title">Custom public image:</span> {{tool.image}}</div>
                  </div>

                </div>
              </div>
            </div>

            <div class="card jepl_files" v-else-if="tab_selected === 'files'" key="jepl_files">
              <div class="card-body">

                <button class="btn btn-primary btn-fill download_all_files" @click="generateFiles()"><i class="fa fa-download "></i> Download all files</button>

                <nav class="nav nav-tabs nav-fill jepl_files_nav" role="tablist">
                  <button class="nav-link active" data-toggle="tab" data-target="#panel-config" type="button" role="tab">Main Configuration</button>
                  <button class="nav-link" data-toggle="tab" data-target="#panel-composer" type="button" role="tab">Composer</button>
                  <button class="nav-link" data-toggle="tab" data-target="#panel-jenkinsfile" type="button" role="tab">Jenkinsfile</button>
                </nav>

                <div class="tab-content jepl_files_tab-content">

                  <div class="tab-pane fade show active" id="panel-config" role="tabpanel">
                    <div class="flex" style="display: flex">

                      <nav class="nav nav-tabs flex-column config_files_nav" role="tablist">
                        <button v-for="(jepl_config, index) in pipeline_jepl_config" :key="index" class="nav-link" :class="{'active':index === 0}" data-toggle="tab" :data-target="'#nav-'+index" role="tab">{{jepl_config.file_name.substring(0, 10) + (jepl_config.file_name.length > 10 ? '...':'')}}</button>
                      </nav>

                      <div class="tab-content config_files_nav_tab-content">
                        <div v-for="(jepl_config, index) in pipeline_jepl_config" :key="index" class="tab-pane fade" :class="{'active': index === 0, 'show': index === 0}" :id="'nav-'+index" role="tabpanel">
                          <div class="filename"><span><b>File name: </b>{{jepl_config.file_name}}</span> <button class="btn btn-primary btn-simple" @click="downloadFile(jepl_config.content, jepl_config.file_name)"><i class="fa fa-download"></i></button></div>
                          <editor :editor-id="'editor-config-'+index" :content="jepl_config.content" lang="yaml"  :key="'editor-config'+index"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="panel-composer" role="tabpanel">

                    <div class="filename"><span><b>File name: </b>docker-compose.yml</span> <button class="btn btn-primary btn-simple" @click="downloadFile(pipeline_composer, 'docker-compose.yml')"><i class="fa fa-download"></i></button></div>
                    <editor editor-id="editor-composer" :content="pipeline_composer" lang="yaml"/>

                  </div>

                  <div class="tab-pane fade" id="panel-jenkinsfile" role="tabpanel">

                    <div class="filename"><span><b>File name: </b>Jenkinsfile</span> <button class="btn btn-primary btn-simple" @click="downloadFile(pipeline_jenkinsfile, 'Jenkinsfile')"><i class="fa fa-download"></i></button></div>
                    <editor editor-id="editor-jenkinsfile" :content="pipeline_jenkinsfile" lang='json'/>

                  </div>

                </div>

              </div>
            </div>

            <div class="card pull_request" v-else-if="tab_selected === 'pull_request'" key="pull_request">
              <div class="card-body">

                <div class="input" style="display: flex">
                  <base-input class="pull_request_input_url" type="text" required label="Repository URL" addon-left-icon="fa fa-archive" v-model="pull_request.url" />
                  <base-input class="pull_request_input_branch" type="text" label="Branch" placeholder="master" addon-left-icon="fa fa-code-fork" v-model="pull_request.branch" />
                </div>

                <div class="only_github"><i class="fa fa-bell"></i> Only Github repositories are allowed</div>

                <button v-if="!pull_request.result_url" type="button" class="btn btn-primary btn-fill pull_request_button" :disabled='!pull_request.url || pull_request.in_progress' @click="pullRequest()"><i class="fa fa-upload"></i> {{pull_request.in_progress? "Pulling..." : "Pull"}}</button>

                <div v-else class="pull_request_done"><i class="fa fa-check"></i> Pull Request successfully done <a class="btn btn-primary btn-fill btn-sm" :href="pull_request.result_url" target="_blank">Go to the PR</a></div>

              </div>
            </div>

            <div class="card run_pipeline" v-else-if="tab_selected === 'run_pipeline'" key="run_pipeline">
              <div class="card-body">

                <div v-if="all_external_repos_defined">
                  <i class="fas fa-info-circle"></i> Since all tools have its external repositories defined, there's no need to specify any additional repository.
                </div>
                <div v-else>
                  <div class="input" style="display: flex">
                    <base-input class="run_pipeline_input_url" type="text" required label="Repository URL" addon-left-icon="fa fa-archive" v-model="try_out.url"></base-input>
                    <base-input class="run_pipeline_input_branch" type="text" label="Branch" addon-left-icon="fa fa-code-fork" placeholder="master" v-model="try_out.branch"></base-input>
                  </div>

                  <div class="public_repo"><i class="fa fa-bell"></i> Repository must be public for the checkout to work</div>
                </div>

                <base-checkbox class="force_completion" label="Force the pipeline to run to completion" help="Enabling this option makes the pipeline run past failed stages" v-model="try_out.force_completion" />

                <button type="button" class="btn btn-primary btn-fill try_out_button" :disabled="!all_external_repos_defined && try_out.url === ''"  @click="runPipeline()"><i class="fa fa-play"></i> Run/Try Pipeline</button>

              </div>
            </div>
          </transition>
        </div>


      </div>

    </div>

  </div>
</div>
</template>

<script>

  import Services from "@/services/services";
  import editor from "@/pages/AceEditor.vue";
  import YAML from "json-to-pretty-yaml";
  import FileSaver from 'file-saver';
  import JSZip from "jszip";


  export default {
    components: {editor},

    mixins: [Services],

    data () {
      return {
        criteria: this.$store.state.criteria,

        pipeline_status: 'creating', // 'created', 'error'
        pipeline_error_description: "",
        pipeline_id: "",
        pipeline_jepl_config: [],
        pipeline_composer: "",
        pipeline_jenkinsfile: "",

        pipeline_loading_counter: 0,

        pull_request: {
          url: '',
          branch: '',
          in_progress: false,
          result_url: ''
        },

        try_out: {
          url: '',
          branch: '',
          force_completion: false,

          showModal: false,
          autoRefresh: false,
          build_title : undefined,
          build_status: undefined,
          build_url: undefined

        },

        tab_selected: 'summary' // 'summary','files','pull_request','run_pipeline'

      }
    },

    created(){

      this.createPipeline();

      //let r = Math.floor(Math.random() * 3)
      //if(r === 0) this.pipeline_status = 'creating'
      //if(r === 1) this.pipeline_status = 'created'
      //if(r === 2) this.pipeline_status = 'error'

    },
    mounted(){

      $('[data-toggle="tooltip"]').tooltip()

    },

    computed:{
      all_external_repos_defined(){
        // If all tools have external repo defined, there's no need to fulfill 'repository URL' field
        return this.criteria.criteria.every(criteria => criteria.tools.every(tool => tool.external_repo.url !== ''))
      },
    },
    watch:{
      'pipeline_loading_counter'(val){
        if(val === 5) this.pipeline_status = 'created'
      },
      'try_out.autoRefresh'(val) {
        if (val)
          this.t = setInterval(() => { this.checkStatus() }, 10 * 1000)
        else
          clearInterval(this.t)
      }
    },
    methods:{

      createPipeline(){

        console.log('%c----%c createPipeline()', 'color: goldenrod','')

        let criteria = this.criteria

        // Replace the default images on tools by the custom images
        criteria.criteria[0].tools.map(tool => tool.tool.docker.image = tool.image)

        let data =
          {
              "name": criteria.pipeline_name,
              "composer_data": {
                  "services": {},
                  "version": "3.7"
              },
              "config_data": [
                  {
                      "config":{
                        "project_repos": criteria.external_repos.map(({url,branch}) => ({repo: url, branch: branch})),
                        "credentials" : []
                      },
                      "environment" : criteria.custom_env.reduce((result, env) => ({...result, [env.key]: env.value}), {}),
                      "sqa_criteria": criteria.criteria.reduce((result, criteria) => ({ ...result,
                        [criteria.criterionID]: {
                          repos:
                            criteria.tools.map(tool => ({
                              repo_url: tool.external_repo.url,
                              container: "",
                              tool: tool.tool
                            }))
                        }
                       }), {}),
                      "timeout": undefined

                  }
              ],
              "jenkinsfile_data": {
                  "stages": [
                      {
                          "pipeline_config": {
                              "base_branch": "https://github.com/jenkins-docs/simple-java-maven-app",
                              "base_repository": "master",
                              "config_file": "./.sqa/config.yml",
                              "credentials_id": "userpass_dockerhub",
                              "jepl_validator_docker_image": "eoscsynergy/jpl-validator:1.1.0"
                          },
                          "when": {
                              "branches": [
                                  "master"
                              ]
                          }
                      }
                  ]
              }
          }

        console.log('%c<---%c createPipelineCall()','color: red','')
        console.log(data)
        this.createPipelineCall(data,this.createPipelineCallBack)

      },
      createPipelineCallBack(response){
        console.log('%c--->%c createPipelineCallBack()','color: lime','')
        console.log(response);

        if(response.status === 201){ // 201 Created

          this.pipeline_id = response.data.id

          console.log('%c<---%c getConfigCall()','color: red','')
          console.log(this.pipeline_id)
          console.log('%c<---%c getBuilderScriptCall()','color: red','')
          console.log(this.pipeline_id)
          console.log('%c<---%c getComposerCall()','color: red','')
          console.log(this.pipeline_id)
          console.log('%c<---%c getJenkCall()','color: red','')
          console.log(this.pipeline_id)

          this.pipeline_loading_counter++;
          this.getConfigCall(this.pipeline_id,this.getConfigCallBack);
          this.getBuilderScriptCall(this.pipeline_id,this.getBuilderScriptCallBack);
          this.getComposerCall(this.pipeline_id,this.getComposerCallBack);
          this.getJenkCall(this.pipeline_id,this.getJenkCallBack);
        }
        else{
          this.pipeline_status = 'error'
          this.pipeline_error_description = "Error during pipeline creation"
        }

      },

      getConfigCallBack(response){
        console.log('%c--->%c getConfigCallBack()','color: lime','')
        console.log(response);

        if(response.status === 200){
          this.pipeline_jepl_config = this.pipeline_jepl_config.concat(
            response.data.map( jepl_config => ({
              file_name: jepl_config.file_name.split("/").at(-1),
              content: YAML.stringify(jepl_config.content, undefined, 2)
            }))
          )
          this.pipeline_loading_counter++;
        }
        else{
          this.pipeline_status = 'error'
          this.pipeline_error_description = "Error during JePL config recovery"
        }
      },
      getBuilderScriptCallBack(response){
        console.log('%c--->%c getBuilderScriptCallBack()','color: lime','')
        console.log(response);

        if(response.status === 200){
          this.pipeline_jepl_config = this.pipeline_jepl_config.concat(
            response.data.map( jepl_config => ({
              file_name: jepl_config.file_name.split("/").at(-1),
              content: jepl_config.content
            }))
          )
          this.pipeline_loading_counter++;
        }else{
          this.pipeline_status = 'error'
          this.pipeline_error_description = "Error during builder script recovery"
        }
      },
      getComposerCallBack(response){
        console.log('%c--->%c getComposerCallBack()','color: lime','')
        console.log(response);

        if(response.status === 200){
          this.pipeline_composer = YAML.stringify(response.data.content)
          this.pipeline_loading_counter++;
        }else{
          this.pipeline_status = 'error'
          this.pipeline_error_description = "Error during composer recovery"
        }

      },
      getJenkCallBack(response){
        console.log('%c--->%c getJenkCallBack()','color: lime','')
        console.log(response);

        if(response.status === 200){
          this.pipeline_jenkinsfile = response.data.content;
          this.pipeline_loading_counter++;
        }else{
          this.pipeline_status = 'error'
          this.pipeline_error_description = "Error during jenkinsfile recovery"
        }
      },



      generateFiles(){

        // Download via API
        //this.downloadFileCall(this.pipeline_id, this.downloadFileCallBack);

        let zip = new JSZip();
        let folder_sqa = zip.folder(".sqa")
        this.pipeline_jepl_config.forEach((jepl_config) => folder_sqa.file(jepl_config.file_name, jepl_config.content))
        folder_sqa.file("docker-compose.yml", this.pipeline_composer)
        zip.file("Jenkinsfile", this.pipeline_jenkinsfile)
        zip.generateAsync({type:"blob"}).then(function(zip) {
            FileSaver.saveAs(zip, "SQAaaS-JePL-files.zip");
        });

      },
      downloadFileCallBack(response){
        if(response.status === 200){
          FileSaver(response.data, "SQAaaS-JePL-files.zip")
        }else if(response.status === 403){
          this.showStatus = false;
          this.logout_egi()
        }else{
          this.showStatus = false;
          this.$swal.fire({
            title: 'An unexpected error occurred while downloading the files!',
            text: response.detail?response.detail:response.reason?response.reason:response.data?response.data:'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
            confirmButtonColor: '#E14726',
          })
        }
      },
      downloadFile(content, filename){
        let blob = new Blob([content], {type: "plain/plain;charset=utf-8"});
        FileSaver.saveAs(blob, filename)
      },

      pullRequest(){

        this.pull_request.in_progress = true;

        let data = {
          "repo": this.pull_request.url,
          "branch": this.pull_request.branch
        }

        console.log('%c<---%c pullRequest()','color: red','')
        console.log(this.pipeline_id)
        console.log(data)
        this.pullRequestCall(this.pipeline_id, data, this.pullRequestCallBack);
      },
      pullRequestCallBack(response){
        console.log('%c--->%c pullRequestCallBack()','color: lime','')
        console.log(response);

        this.pull_request.in_progress = false;

        if(response.status === 200){
          if (response.data.pull_request_url){
            this.pull_request.url = ''
            this.pull_request.branch = ''
            this.pull_request.result_url = response.data.pull_request_url;
          }
        }else if(response.status === 403){
          this.logout_egi()
        }else{
           this.$swal.fire({
              title: 'An unexpected error occurred while running the assessment!',
              text: response.detail?response.detail:response.reason?response.reason:response.data?response.data:'Error',
              icon: 'error',
              confirmButtonText: 'Close',
              footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
              confirmButtonColor: '#E14726',
            })
        }

      },

      runPipeline(){
        this.try_out.showModal = true;
        this.try_out.build_title = 'Submitting Pipeline...'

        let data = {
          id: this.pipeline_id,
          url: this.try_out.url,
          branch: this.try_out.branch,
          keepgoing: this.try_out.force_completion
        }

        console.log('%c<---%c runPipeline()','color: red','')
        console.log(data)
        this.runPipelineCall(data, this.runPipelineCallBack)
      },
      runPipelineCallBack(response){
        console.log('%c--->%c runPipelineCallBack()','color: lime','')
        console.log(response);
        if(response.status === 204){ // 204 No Content
          this.try_out.autoRefresh = true;
        }
        else if(response.status === 403){ // 403 Forbidden
          this.logout_egi()
        }
        else if(response.status === 500){ // 500 Internal Server Error
          this.$swal.fire({
            title: 'An unexpected error occurred while running the pipeline!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data.status + " " + response.data.title + ": " + response.data.detail : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }
        else{
          this.$swal.fire({
            title: 'The pipeline has failed to complete!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }

      },
      checkStatus(){
        this.try_out.build_title = 'Executing Pipeline...'
        console.log('%c<---%c checkStatus()','color: red','')
        console.log(this.pipeline_id)
        this.checkStatusCall(this.pipeline_id, this.checkStatusCallBack)
      },
      checkStatusCallBack(response){
        console.log('%c--->%c checkStatusCallBack()','color: lime','')
        console.log(response)

        if(!this.try_out.showModal) return

        if(response.status === 200){ // 200 OK

          this.try_out.build_url = response.data.build_url;

          if (response.data.build_status.toUpperCase() !== 'NOT_EXECUTED'){
            this.try_out.build_status = response.data.build_status;
          }

          if(response.data.build_status.toUpperCase() === 'SUCCESS' || response.data.build_status.toUpperCase() === 'UNSTABLE'){
            this.$swal.fire({
              title: 'Pipeline was executed successfully!',
              icon: 'success',
              confirmButtonText: 'Close',
              //footer: `<a class='btn btn-info btn-fill btn-sm' style='color:white; font-weight:700; font-size:16px;' href="${this.build_url}" target="_blank">See the build in Jenkins</a>`,
              confirmButtonColor: '#28a745',
            })
            this.closeAssessmentModal()
          }

          if(response.data.build_status.toUpperCase() === "FAILURE" || response.data.build_status.toUpperCase() === "ABORTED"){
            this.$swal.fire({
              title: 'The execution of the pipeline has failed!',
              icon: 'error',
              confirmButtonText: 'Close',
              confirmButtonColor: '#E14726',
              footer: `<a style='color:red' href="${this.try_out.build_url}" target="_blank">Why do I have this issue?</a>`
            })
            this.closeAssessmentModal()
          }
        }

        else if(response.status === 403){ // 403 Forbidden
          this.logout_egi()
        }

        else if (response.status === 422){ // 422 Unprocessable Entity
          this.$swal.fire({
            title: 'Pipeline has not been execute!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
          })
          this.closeAssessmentModal()
        }

        else if(response.status === 500){ // 500 Internal Server Error
          this.$swal.fire({
            title: 'The quality assessment has failed to complete!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            confirmButtonColor: '#E14726',
            footer: `<p style="color: red; font-weight: bold;">Please contact sqaaas@ibergrid.eu</p>`,
          })
          this.closeAssessmentModal()
        }

        else{
          this.$swal.fire({
            title: 'Error!',
            text: response.detail ? response.detail : response.reason ? response.reason : response.data ? response.data : 'Error',
            icon: 'error',
            confirmButtonText: 'Close',
            footer: `<a href="${this.try_out.build_url}" target="_blank">Why do I have this issue?</a>`
          })
          this.closeAssessmentModal()
        }

      },
      cancelPipeline(){
        console.log('%c----%c cancelPipeline(\'' + this.pipeline_id + '\')','color: goldenrod','')
        this.closeAssessmentModal()
      },

      closeAssessmentModal(){
        this.try_out.showModal = false
        this.try_out.autoRefresh = false
        this.try_out.build_title = undefined
        this.try_out.build_status = undefined
        this.try_out.build_url = undefined
      }

    },

  }

</script>

<style scoped>

  .card{
    margin: 2em 1.5em;
    background-color: #FAFAFA;

    .card-header{
      padding: 0.6em;
      background-color: #FAFAFA;

      .card-title{
        font-weight: bold;
        padding-left:5px;
        font-size:18px;
      }
    }

    .card-body{
      display: flex;
      flex-direction: column;
      padding: 0;

      .pipeline-result{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 4em;
        background: #e6ede8;
        margin-bottom: 2em;
        padding: 3em 15%;
        transition: background-color 0.5s ease, padding 0.5s ease;

        &.creating{
          background-color: #edebc2;
          padding: 5em 15%;
          margin-bottom: 0;
          .progress{
            height: 20px;
            border: 1px solid #bfbfbf;
            margin-top: 1em;
          }
        }
        &.created{
          background-color: #c2edd6;
          .fa-download{
            margin-right: 0.5em;
          }
        }
        &.error{
          background-color: #edc2c2;
          .fa-arrow-left{
            margin-right: 0.5em;
          }
        }

        .title{
          font-size: 2em;
          font-weight: bold;
          padding-left: 0;
        }
        .description{
          padding: 0.5rem 10% 1rem 0;
          font-size: 1em;
        }
        .icon img{
          width: 12em;
          opacity: 0.5;
        }
      }

      .tabs{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        margin: 0 3%;
        text-align: center;
        align-items: stretch;

        .tab{
          display: flex;
          flex-direction: column;
          background: linear-gradient(0deg, rgb(182, 217, 243) 0%, rgba(220,237,247,1) 100%);
          transition: background 0.5s, transform 0.5s;

          padding: 2em;
          justify-items: center;
          align-items: center;
          row-gap: 1em;
          cursor: pointer;

          border: 1px solid white;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;

          &:hover{
            background: linear-gradient(0deg, rgb(154, 203, 239) 0%, rgb(205, 230, 244) 100%);
          }

          &.active{
            background: linear-gradient(0deg, rgb(154, 203, 239) 0%, rgb(205, 230, 244) 100%);
            border: 1px solid #92b6e6;
            transform: scale(1.05);
            transform-origin: bottom;
            z-index: 10;
            &.summary{
              transform: scale(1.05) translateX(3%);
            }
            &.run_pipeline{
              transform: scale(1.05) translateX(-3%);
            }
          }

          .title{
            font-weight: bold;
            font-size: 1.25em;
          }

        }
      }

      .card.summary,
      .card.jepl_files,
      .card.pull_request,
      .card.run_pipeline{
        margin: -1px 3% 2em 3%;
        padding: 2em 10%;
      }

      .card.summary{
        .pipeline_name{
          text-align: center;
          padding-bottom: 2em;
          .title{
            font-weight: bold;
          }
        }

        .criteria_item{
          display: flex;
          align-items: center;
          background: linear-gradient(90deg, #eceff2 0%, #F8F8FA 100%);
          margin: 1em 0;
          padding: 0.5em 1em 0.5em 0.8em;
          border-radius: 5px;
          border: solid 1px #d4dadf;

          .fa-compass {
            color: #495057FF;
            padding-right: 1.5em;
          }
        }

        .tool_item{
          padding: 0.5em 1.2em 0 1.5em;

          .tool_title{
            display: flex;
            padding: 0.3em 0.5em 0.1em 0.5em;
            border-bottom: 1px solid #c7d3dd;

            .tool_name {
              flex-grow: 2;
            }

            .fa-cogs {
              color: #495057FF;
              padding-right: 1.7em;
            }

          }

         .tool_data{
            padding-left: 1.5em;
            padding-top: 0.2em;

            .tool_data_title{
              font-size: 0.8em;
              font-weight: bold;
            }
          }

        }
      }

      .card.jepl_files{

        .download_all_files{
          width: 15em;
          margin-bottom: 2em;
          align-self: center;
        }
        .jepl_files_nav{
          button.active{
            background: linear-gradient(180deg, #F4F4E9 0%, white 80%);
          }
        }
        .jepl_files_tab-content{

          #panel-config,
          #panel-composer,
          #panel-jenkinsfile{
            background-color: white;
            border: solid 1px #DDD;
            border-top: none;
            padding: 1.5em;
            margin-bottom: 1em;
            .filename{
              padding-left: 1.5em;
            }
          }

          #panel-config{

            .flex{
              display: flex;
              .config_files_nav{
                margin-right: -1px;
                z-index: 1;
                border: none;
                button{
                  border: 1px solid transparent;
                  border-left: 3px solid transparent;
                  border-radius: 4px 0 0 4px;
                  &.active{
                    border: 1px solid #DDD;
                    border-left: 3px solid #FF7588;
                    border-right: 1px solid white;
                  }
                }
              }
              .config_files_nav_tab-content{
                border-left: 1px solid #DDD;
                width: 100%;
                padding-left: 1em;

              }
            }
          }
        }

      }

      .card.pull_request{
        .input{
          display: flex;
          gap: 2em;
          .pull_request_input_branch{
            width: max(40%, 300px);
          }
        }

        .only_github{
          font-style:italic;
          color: #979797;
          padding-left: 1em;
          .fa-bell{
            color: #afaa87
          }
        }

        .pull_request_button{
          margin-top: 1em;
          width: 12em;
          align-self: center;
          &:disabled{ cursor: not-allowed; }
        }

        .pull_request_done{
          text-align: center;
          margin-top: 1em;
          i{ color: green; }
          a{ margin-left: 1em; }
        }
      }

      .card.run_pipeline{

        .fa-info-circle{
          color: #146EBE;
          padding-right: 0.4em;
        }

        .input{
          display: flex;
          gap: 2em;
          .run_pipeline_input_branch{
            width: max(40%, 300px);
          }
        }

        .public_repo{
          font-style: italic;
          color: #979797;
          padding-left: 1em;
          .fa-bell{
            color: #afaa87
          }
        }

        .force_completion{
          margin-top: 1.5em
        }

        .try_out_button{
          margin-top: 1em;
          width: 20em;
          align-self: center;
          &:disabled{ cursor: not-allowed; }
        }
      }

      .fade-enter-active, .fade-leave-active {
        transition: opacity .2s
      }
      .fade-enter, .fade-leave-to {
        opacity: 0
      }

    }

  }

  .assessment-modal-overlay {
    display: flex;
    background: rgba(240, 240, 240, 0.4);
    backdrop-filter: blur(3px);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 9998;
    align-items: center;
    justify-content: center;

    .assessment-modal{
      padding: 26px 46px;
      background-color: #ccc;
      border-radius: 5px;
      box-shadow: rgba(0, 0, 0, 0.3) 0 15px 38px, rgba(0, 0, 0, 0.22) 0 12px 12px;
      will-change: transform; /* Prevent blur on scaling */

      .title{
        display: flex;
        align-items: center;
        padding-bottom: 0.5em;
        .build_title{
          padding-left: 1em;
          text-transform: uppercase;
          font-weight: bold;
        }
      }

      .description{
        padding-bottom: 0.6em;
      }

      .build_status{
        font-size:18px;
        font-weight:700;
        text-align: center;
        padding-bottom: 0.6em;
      }

      .buttons{
        display: flex;
        justify-content: space-evenly;
        a{
          color: white;
        }
      }
    }
  }


@media (width < 1000px) {

  .card{
    .card-body{

      .pipeline-result{
        .icon{ display: none;}
        text-align: center;
        padding: 2em 5%;
        .description{
          padding: 0.5rem 0 1rem 0;
        }
      }

      .tabs{
        .tab{
          padding: 1em;
          img{
            width: 1.8em;
          }
          .title{
            font-size: 1em;
            font-weight: normal;
          }
          .description{
            display: none;
          }
        }
      }

      .card.summary,
      .card.jepl_files,
      .card.pull_request,
      .card.run_pipeline{
        margin: -1px 3% 2em 3%;
        padding: 2em 5%;
      }

      .card.summary{
        .tool_item{
           padding: 0.5em 0 0 0;
        }
      }

       .card.jepl_files{
         .jepl_files_tab-content{

            #panel-config,
            #panel-composer,
            #panel-jenkinsfile{
              .filename{
                padding-left: 0;
              }
           }

            #panel-config{
              .flex{
                flex-flow: column;
                .config_files_nav{
                  button{
                    &.active{
                    border-right: 1px solid #DDD;
                      border-radius: 4px;
                    }
                  }
                }
                .config_files_nav_tab-content{
                  border-left: none;
                  padding-left: 0;
                }
              }
            }
         }

       }


      .card.pull_request{
        .input{
          flex-flow: column;
          gap: 0;
          .pull_request_input_branch{
            width: 100%;
          }
        }
      }

      .card.run_pipeline{
        .input{
          flex-flow: column;
          gap: 0;
          .run_pipeline_input_branch{
            width: 100%;
          }
        }
      }
    }
  }


}


</style>
